// Private enrichment is progressive: public catalog summaries and the Studio
// review link remain usable if cart release or signed identity is unavailable.
const sessions=new WeakMap();
export function clearStudioCartReviews(document) {
  const previous=sessions.get(document);previous?.controller.abort();
  sessions.set(document,{revision:(previous?.revision||0)+1,controller:new AbortController()});
  document.querySelectorAll('[data-private-cart-content]').forEach(node=>node.remove());
}
export async function hydrateStudioCartReviews({document,fetchImpl=fetch}={}) {
  clearStudioCartReviews(document);
  const session=sessions.get(document),current=()=>sessions.get(document)===session&&!session.controller.signal.aborted;
  const root=document.querySelector('[data-studio-cart-bridge]');
  if(root?.dataset.enabled!=='true'||root.dataset.proxyPath!=='/apps/canvas3d-studio')return;
  const prefix=root.dataset.proxyPath;
  await Promise.all([...document.querySelectorAll('[data-studio-private-review]')].map(async mount=>{
    const reference=mount.dataset.studioPrivateReview;
    if(!/^[A-Za-z0-9_-]{40,128}$/.test(reference||''))return;
    const content=mount.querySelector('[data-studio-private-review-content]')||mount;
    // Remove stale private data before a re-read (including restored pages).
    content.querySelectorAll('[data-private-cart-content]').forEach(node=>node.remove());
    try {
      const response=await fetchImpl(`${prefix}/review?reference=${encodeURIComponent(reference)}`,{credentials:'same-origin',cache:'no-store',redirect:'error',signal:session.controller.signal});
      if(!current()||!response.ok)return;
      const summary=await response.json();
      if(!current())return;
      const imagePath=`${prefix}/image?reference=${encodeURIComponent(reference)}`;
      if(summary.reference!==reference||summary.imagePath!==imagePath)return;
      const region=document.createElement('div');region.dataset.privateCartContent='';
      const image=document.createElement('img');image.alt='Your selected figurine concept';image.width=240;image.height=240;
      image.style.cssText='width:240px;max-width:100%;height:auto;object-fit:contain;border-radius:12px';
      image.referrerPolicy='same-origin';
      image.addEventListener('error',()=>image.remove(),{once:true});image.addEventListener('load',()=>{if(!current())image.remove();},{once:true});image.src=imagePath;region.append(image);
      for(const [label,value] of [['Subject',summary.subject],['Artist notes',summary.notes]]) {
        if(typeof value!=='string'||!value.trim())continue;
        const p=document.createElement('p'),strong=document.createElement('strong');strong.textContent=`${label}: `;
        p.append(strong,document.createTextNode(value));region.append(p);
      }
      content.append(region);
    }catch{/* Fail closed; the existing owner-scoped Studio review link remains. */}
  }));
}
export function bindStudioCartReviewLifecycle({document,window,fetchImpl=fetch}) {
  let departed=false;
  const clear=()=>clearStudioCartReviews(document);
  const start=()=>{if(!departed&&document.visibilityState!=='hidden')return hydrateStudioCartReviews({document,fetchImpl});};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  window.addEventListener('pagehide',()=>{departed=true;clear();});
  window.addEventListener('pageshow',event=>{departed=false;if(event.persisted)start();});
  window.addEventListener('blur',clear);
  window.addEventListener('focus',start);
  document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='hidden')clear();else start();});
}
if(typeof document!=='undefined')bindStudioCartReviewLifecycle({document,window});
